module.exports = __webpack_public_path__ + "media/images/launch-62a58559bb96ab15a76bced515a6e28f.png";